import { Box } from '@mui/material';
import { useAppSelector } from '../app/hooks';
import Loader from '../components/loader';
import { selectIsLoading } from '../features/attendance/staff-attendance.slice';
import useStaffAttendance from '../hooks/use-staff-attendance';
import useStaffAttendanceSummary from '../hooks/use-staff-attendance-summary';
import StaffAttendanceSummaryView from '../features/attendance/staff/staff-attendance-summary';
import StaffAttendanceTable from '../features/attendance/staff/staff-attendance-table';

const StaffAttendancePage = () => {
    const isLoading = useAppSelector(selectIsLoading);

    const [staffAttendances] = useStaffAttendance();
    const attendanceSummary = useStaffAttendanceSummary();

    return (
        <Box>
            {isLoading && <Loader />}

            {staffAttendances &&
                <StaffAttendanceSummaryView attendanceSummary={attendanceSummary} />
            }

            {/* <Box sx={{ mt: 3, backgroundColor: '#fff', borderRadius: 2, overflow: 'hidden' }}> */}

                <StaffAttendanceTable staffAttendances={staffAttendances} />
            {/* </Box> */}
        </Box>
    );
};

export default StaffAttendancePage;
